import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_vxe_radio = _resolveComponent("vxe-radio");
  return _openBlock(), _createBlock(_component_vxe_radio, _mergeProps(_ctx.$attrs, {
    "model-value": $props.value,
    disabled: _ctx.disabled,
    readonly: _ctx.readonly,
    size: _ctx.size,
    label: $props.label,
    title: $props.title,
    name: $props.name,
    onChange: $setup.handleChanged
  }), {
    default: _withCtx(() => [_renderSlot(_ctx.$slots, "default", {}, () => [_createTextVNode(_toDisplayString($props.title), 1)])]),
    _: 3
  }, 16, ["model-value", "disabled", "readonly", "size", "label", "title", "name", "onChange"]);
}